/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalUserResponse } from './ExternalUserResponse';
import {
    ExternalUserResponseFromJSON,
    ExternalUserResponseFromJSONTyped,
    ExternalUserResponseToJSON,
    ExternalUserResponseToJSONTyped,
} from './ExternalUserResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface ExternalUserResponsePagedResult
 */
export interface ExternalUserResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof ExternalUserResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<ExternalUserResponse>}
     * @memberof ExternalUserResponsePagedResult
     */
    data: Array<ExternalUserResponse> | null;
}

/**
 * Check if a given object implements the ExternalUserResponsePagedResult interface.
 */
export function instanceOfExternalUserResponsePagedResult(value: object): value is ExternalUserResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ExternalUserResponsePagedResultFromJSON(json: any): ExternalUserResponsePagedResult {
    return ExternalUserResponsePagedResultFromJSONTyped(json, false);
}

export function ExternalUserResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalUserResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(ExternalUserResponseFromJSON)),
    };
}

export function ExternalUserResponsePagedResultToJSON(json: any): ExternalUserResponsePagedResult {
    return ExternalUserResponsePagedResultToJSONTyped(json, false);
}

export function ExternalUserResponsePagedResultToJSONTyped(value?: ExternalUserResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(ExternalUserResponseToJSON)),
    };
}

